import {
  useState, useEffect, SetStateAction
} from 'react';

interface UseInfiniteScrollArgs<T> {
  total: number;
  currentItems: T[];
  isFetching: boolean;
  isLoading: boolean;
  isError?: boolean;
  currentPage: number;
  setCurrentPage: (value: SetStateAction<number>) => void;
  rootMargin?: string;
}

export const useFiltersInfiniteScroll = <T>({
  total,
  currentItems,
  isFetching,
  isLoading,
  isError,
  currentPage,
  setCurrentPage,
}: UseInfiniteScrollArgs<T>) => {
  const [allItems, setAllItems] = useState<T[]>([]);

  useEffect(
    () => {
      if (currentPage > 1) {
        setAllItems((prev) => [...prev, ...currentItems]);
      } else {
        setAllItems(currentItems);
      }
    },
    [currentItems]
  );

  const hasNextPage = total > allItems.length;

  const loading = isFetching || isLoading;

  const onLoadMore = () => {
    if (loading) {
      return;
    }

    setCurrentPage((prev) => prev + 1);
  };

  return {
    allItems,
    onLoadMore,
    hasNextPage,
    loading,
    isError,
    setAllItems,
  };
};

export type UseFiltersInfiniteScroll<T> = ReturnType<
  typeof useFiltersInfiniteScroll<T>
>;
